import React from "react";
import "./Foreclosuresdetails.css";
import { FiTrash } from "react-icons/fi";
import junk from "../../Assests/IMG_0960.webp";

const Foreclosuresdetails = () => {
  return (
    <section className="Foreclosuresdetails-section">
      <div className="Foreclosuresdetails-container">
        {/* Content Column */}
        <div className="Foreclosuresdetails-content">
          <div className="Foreclosuresdetails-content-header">
            <div className="Foreclosuresdetails-service-icons">
              <FiTrash size={32} />
            </div>
            <h1 className="Foreclosuresdetails-service-title">
              <span className="Foreclosuresdetails-title-accent">Foreclosures </span> & Evictions
            </h1>
          </div>

          <p className="Foreclosuresdetails-service-description">
            Foreclosure and eviction cleanouts often come with tight deadlines and overwhelming messes,
            but our team is equipped to handle them quickly and thoroughly. We clear out clutter, furniture,
            abandoned belongings, and trash from interiors, garages, sheds, and yards—leaving properties clean
            and ready for resale, rental, inspection, or renovation. With fast turnaround times, full property
            coverage inside and out, and a commitment to finishing every job completely, you can count on us
            for reliable results.
          </p>

          <p className="Foreclosuresdetails-service-description">
            From furniture and personal items to outdoor goods, garage contents, and general debris, we haul
            it all and ensure responsible disposal for a stress-free cleanout. We work closely with property
            managers, realtors, and landlords to meet tight schedules. Every job is handled with care,
            professionalism, and respect for the property. Our goal is to restore spaces quickly so they’re
            ready for new opportunities without delay.
          </p>

          <div className="Foreclosuresdetails-cta-group">
            <a
              href="https://app.squareup.com/appointments/book/41vplmwf0luh01/LTHMTFD90TMRT/start"
              className="Foreclosuresdetails-primary-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Your Pickup
              <span className="Foreclosuresdetails-cta-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Image Column */}
        <div className="Foreclosuresdetails-image">
          <div className="Foreclosuresdetails-image-wrapper">
            <img
              src={junk}
              alt="Foreclosure and eviction cleanout team clearing property items"
              className="Foreclosuresdetails-main-image"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Foreclosuresdetails;
